import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 10 10"
    >
      <path
        fill={colorValue}
        fillOpacity={1}
        d="M5 .125a4.875 4.875 0 1 0 0 9.75 4.875 4.875 0 0 0 0-9.75M9.125 5c0 .53-.101 1.054-.3 1.544L6.73 5.255a.75.75 0 0 0-.293-.104l-1.07-.144a.76.76 0 0 0-.75.368H4.21l-.178-.368a.75.75 0 0 0-.516-.407l-.375-.08.367-.645h.783a.75.75 0 0 0 .362-.094l.574-.317a.8.8 0 0 0 .141-.1l1.261-1.14a.75.75 0 0 0 .153-.922l-.017-.03A4.13 4.13 0 0 1 9.125 5M5.718.938l.407.73-1.261 1.14-.574.317h-.783a.75.75 0 0 0-.651.375l-.41.714-.475-1.268.513-1.212A4.12 4.12 0 0 1 5.718.937M.875 5c0-.613.136-1.219.4-1.772l.532 1.419a.75.75 0 0 0 .545.469l1.004.216.179.371a.75.75 0 0 0 .675.422h.07l-.34.76a.75.75 0 0 0 .134.815l.007.007.919.946-.09.47A4.13 4.13 0 0 1 .874 5m4.808 4.068.053-.273a.75.75 0 0 0-.194-.658l-.917-.946.642-1.441 1.07.144L8.48 7.213a4.13 4.13 0 0 1-2.797 1.855"
      ></path>
    </svg>
  );
};
